import { useMutation } from '@tanstack/react-query';

import { CloneVoucherRequestBody, CloneVoucherResponse, cloneVoucher } from '~/services/PromoService';

export function useCloneVoucher() {
  return useMutation<CloneVoucherResponse, Error, CloneVoucherRequestBody>({
    mutationFn: async (payload) => cloneVoucher(payload),
  });
}
